exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n:root {\n  --button-size: 4.5vw;\n  --button-margin: 0.5vw;\n}\n", ""]);

// exports
